module.exports = __webpack_public_path__ + "static/media/kiosk-logo.991afc37.png";